<script>
  import { createNamespacedHelpers } from 'vuex';
  import axios from 'axios';
  import { eventBus } from '../../main';

  const { mapGetters } = createNamespacedHelpers('plate');

  export default {
    name: 'AddToCart',
    props: {
      letterStyle: {
        /** the currently selected letter style */
        type: Object,
        required: true,
      },
      sku: {
        /** product sku */
        type: String,
        required: true
      },
      title: {
        /** product title */
        type: String,
        required: true
      },
      entryId: {
        /** product title */
        type: Number,
        required: true
      },
      redirectUrl: {
        /** store cart redirect url */
        type: String,
        required: true
      },
      /** product bundle type ID */
      bundleId: {
        type: [Number, String],
        default: 2
      },
      /** Promotion Categories on customizable product */
      promotionCategories: {
        type: String,
        default: '',
      }
    },
    watch: {
      letterStyle() {
        /** watch for letterStyle changes to recompute total price */
        this.getTotalPrice();
      }
    },
    computed: {
      ...mapGetters([
        'getInputErrorArray',
        'getCsrfToken',
        'getSelectedVariant',
        'getSelectedLetterStyle',
        'getAllProducts',
        'getEntryId'
      ]),
      getBaseProductPrice() {
        return '$' + parseFloat(this.getSelectedVariant.price).toFixed(2);
      },
      getLetterPriceRange() {
        /** gets price range for selected lettersStyle */
        let priceString = '';
        let priceArray = [];
        let lowestPrice = 0;
        let highestPrice = 0;
        this.letterStyle.chars.forEach((char) => {
          char.price = char.price > char.salePrice ? char.salePrice : char.price;
          priceArray.push(char.price);
        });
        priceArray.sort();
        if (priceArray.length) {
          lowestPrice = priceArray[0];
          highestPrice = priceArray.slice(-1).pop();
        }
        if (lowestPrice === highestPrice) {
          priceString = '$' + parseFloat(highestPrice).toFixed(2);
        } else {
          priceString = '$' + parseFloat(lowestPrice).toFixed(2) + '-' + ('$' + parseFloat(highestPrice).toFixed(2));
        }
        return priceString;
      },
    },
    data() {
      return {
        bundleData: null,
        totalPrice: 0,
        filteredTextArrayLength: 0,
        totalCharLength: 0,
        filteredLettersId: [],
        bundleRequestData: {
          qty: {},
          products: [],
          action: 'bundle-mate/default/make-bundle',
          typeId: this.bundleId,
          quantity: 1,
          title: '',
          sku: ''
        },
        disableCartBtn: false,
        addToCartButtonText: 'Add To Cart',
        error: false
      };
    },
    methods: {
      bundleCustomizedProductData() {
        /** build request to add customized product to cart */
        this.bundleRequestData.qty = {};
        this.bundleRequestData.products = [];
        this.bundleRequestData.csrf = this.getCsrfToken;
        this.bundleRequestData.title = this.title;
        this.bundleRequestData.sku = this.sku;
        if (this.filteredLettersId.length > 0){
          let qty = 0;
          this.filteredLettersId.forEach((id) => {
            qty = this.occurrencesOfLetterId(id,this.filteredLettersId);
            this.bundleRequestData.qty[id] = qty;
          });
          this.getProductsId();
        }
      },
      getProductsId() {
        /**
         * loops through qty obj to populate the products array
         * with the chosen products
         */
        for (const key in this.bundleRequestData.qty) {
          this.bundleRequestData.products.push(key);
        }
      },
      occurrencesOfLetterId(id,arrayId){
        let count = 0;
        count = arrayId.filter(letterId => letterId === id).length;
        return count;
      },
      getProductByChar(char, array) {
        let product = null;
        const charProduct = array.filter((l) => l.key === char);
        if (charProduct.length) {
          product = charProduct[0];
        }
        return product;
      },
      getTotalPrice() {
        /** Adds base product price (frame) to total price for letters in bundleText */
        let totalPrice = 0;
        let totalLetterPrice = 0;
        let totalCharLength = 0;
        let filteredTextArray = [];
        this.filteredLettersId = [];
        if (this.bundleData){
          // checks for errors from the errorArray in bundleData
          this.error = this.checkForErrors();
          filteredTextArray = this.bundleData.textArray.filter(text => text !== '');
          if (filteredTextArray.length > 0){
            filteredTextArray.forEach((text) => {
              let stringArr = text.split('');
              for (let i = 0; i < stringArr.length; i++) {
                let charProduct = this.getProductByChar(
                  stringArr[i],
                  this.letterStyle.chars
                );
                if (charProduct) {
                  // get all chosen/filtered product id
                  this.filteredLettersId.push(charProduct.id);
                  charProduct.price = charProduct.price > charProduct.salePrice ?
                    charProduct.salePrice : charProduct.price;
                  totalLetterPrice += parseFloat(charProduct.price);
                  totalCharLength++;
                }
              }
            })
          }
        }
        totalPrice = (this.getSelectedVariant.price > this.getSelectedVariant.salePrice ?
           this.getSelectedVariant.salePrice : this.getSelectedVariant.price) + totalLetterPrice;
        this.filteredTextArrayLength = filteredTextArray.length;
        this.totalCharLength = totalCharLength;
        this.totalPrice = totalPrice.toFixed(2);
        this.bundleCustomizedProductData();
      },
      checkForErrors() {
        /** checks for errors in various lines of text */
        let error = false;
        this.getInputErrorArray.forEach((errorVal) => {
          if (errorVal){
            error = errorVal;
          }
        });
        return error;
      },
      submitCart() {
        this.disableCartBtn = true;
        this.addToCartButtonText = 'Adding...';
        // add product frame/qty
        this.bundleRequestData.products.push(`${this.getSelectedVariant.id}`);
        this.bundleRequestData.qty[this.getSelectedVariant.id] = 1;
        const formData = new FormData();
        formData.append('CRAFT_CSRF_TOKEN',this.bundleRequestData.csrf);
        formData.append('action', this.bundleRequestData.action);
        formData.append('typeId', this.bundleRequestData.typeId);
        formData.append('quantity',this.bundleRequestData.quantity);
        formData.append('title', this.bundleRequestData.title);
        formData.append('sku', this.bundleRequestData.sku);
        formData.append('promotionCategories', this.promotionCategories);
        this.bundleRequestData.products.forEach((product) => {
          formData.append('products[]', product);
        });
        for (const id in this.bundleRequestData.qty) {
          formData.append(`qty[${id}]`,this.bundleRequestData.qty[id]);
        }
        axios.post('/', formData)
          .then((response) => {
            this.addToCart(response.data);
        });
      },
      addToCart(bundle) {
        const filteredTextArray = this.bundleData.textArray.filter(text => text !== '');
        const formData = new FormData();
        const data = {
          csrf: this.getCsrfToken,
          action: 'commerce/cart/update-cart',
          cartUpdatedNotice: 'Added to cart.',
          qty: parseInt(this.bundleRequestData.quantity),
          purchasableId: bundle.bundleId,
          entryId: this.entryId,
          note: `Text Lines: ${filteredTextArray.join(' | ')}`,
          options: {
            'frame': this.getSelectedVariant.name,
            'letterStyle': this.letterStyle.name,
            'letters': filteredTextArray.join(' '),
            'entryId': this.entryId
          }
        };

        formData.append('CRAFT_CSRF_TOKEN',data.csrf);
        formData.append('action',data.action);
        formData.append('cartUpdatedNotice',data.cartUpdatedNotice);
        formData.append('qty',data.qty);
        formData.append('purchasableId',data.purchasableId);
        formData.append('entryId',data.entryId);
        formData.append('note',data.note);
        formData.append('options[frame]',data.options.frame);
        formData.append('options[letterStyle]',data.options.letterStyle);
        formData.append('options[letters]',data.options.letters);
        formData.append('options[entryId]',data.options.entryId);

        axios.post('/', formData)
          .then(() => {
            this.disableCartBtn = false;
            this.addToCartButtonText = 'Add To Cart';
            window.location.href = this.redirectUrl;
          });
      }
    },
    created() {
      this.getTotalPrice();
      eventBus.$on('new-data', (data) => {
        this.bundleData = data;
        this.getTotalPrice();
      });
    },
  };
</script>

<template>
  <div class="product-view__cart">
    <nav v-if="getAllProducts.length > 1" class="product-nav product-view__nav">
      <h3 class="product-nav__heading">Personalize Your Ride</h3>
      <h6 class="product-nav__subheading">Select a product below</h6>
      <ul>
        <li v-for="product in getAllProducts" :key="product.id">
          <a
            v-if="product.id !== getEntryId"
            :href="product.url"
            :style="`background-image: url('${product.thumbnail}');`"
            class="product-nav__link"
          >
            <span class="product-nav__label">{{ product.title }}</span>
          </a>
          <span
            v-else
            :style="`background-image: url('${product.thumbnail}');`"
            class="product-nav__current"
          >
            <span class="product-nav__label">{{ product.title }}</span>
          </span>
        </li>
      </ul>
    </nav>

    <h2 class="product-view__aside-heading">{{ title }}</h2>

    <form class="product-cart--letters product-view__add-to-cart js-add-item" @submit.prevent="submitCart" accept-charset="UTF-8">
      <input type="hidden" class="js-custom-plate__bulk-discount" />
      <h2 class="product-cart__price js-custom-plate__price-display-total">${{ totalPrice }}</h2>
      <h2 class="product-cart__per-char">
        <span>{{ getBaseProductPrice }}</span> base license plate<br/>
        <span>{{ getLetterPriceRange }}</span> per character
      </h2>

      <div class="sidebar-inputs">
        <slot name="inputs" />
      </div>

      <em class="product-cart__chars-counter">
        <span class="js-custom-plate__price-display-count">{{ totalCharLength }}</span>
        characters
      </em>

      <div class="product-cart__bulk">
        <slot name="bulkPricing"></slot>

        <div class="product-cart__bulk-qty">
          <input
            v-model="bundleRequestData.quantity"
            type="text"
            class="js-custom-plate__qty"
            name="qty"
            id="qty"
            placeholder="Qty"
            value="1"
          />
        </div>
      </div>

      <div v-if="filteredTextArrayLength > 0  && error === false" class="product-cart__cta">
        <input
          class="button--primary m-full js-custom-plate__add js-check-add js-add-button"
          type="submit"
          name="submit_this"
          :value="addToCartButtonText"
          :disabled="disableCartBtn"
        />
      </div>
    </form>
    <slot name="shipping"></slot>
    <slot name="widgets"></slot>
  </div>
</template>

<style scoped>
  .sidebar-inputs {
    margin-top: 20px;
  }
  .sidebar-inputs >>> * {
    margin-top: 5px;
  }
  .sidebar-inputs >>> * :first-child {
    margin-top: 0;
  }
</style>